export const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#2B2825',
      border: '5px solid #E88F2A',
      width: '50%',
      height: '30%', 
    },
    overlay: {
        backgroundColor: 'rgba(40,40,40,0.8)',
        zIndex: 999,
    },
  };

export const customStyles2 = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#2B2825',
      border: '5px solid #E88F2A',
      width: '50%',
    },
    overlay: {
        backgroundColor: 'rgba(40,40,40,0.8)',
        zIndex: 999,
    },
  };